export default "__VITE_ASSET__DQfAc4BW__"